import { SELECTION_WORKSPACE_ROUTE_BASE } from './selectionWorkspaceConfig';

function workspaceBase(projectId) {
    return `${SELECTION_WORKSPACE_ROUTE_BASE}/${projectId}`;
}

export function workspaceSelectionRootPath(projectId) {
    return workspaceBase(projectId);
}

export function workspaceSelectionInfoPath(projectId) {
    return `${workspaceBase(projectId)}/info`;
}

export function workspaceSelectionDeclarationsPath(projectId) {
    return `${workspaceBase(projectId)}/declarations`;
}

export function workspaceSelectionDeclarationAddPath(projectId) {
    return `${workspaceBase(projectId)}/declarations/add`;
}

export function workspaceSelectionDeclarationEditPath(projectId, topicId) {
    return `${workspaceBase(projectId)}/declarations/${topicId}`;
}

export function workspaceSelectionVotePath(projectId) {
    return `${workspaceBase(projectId)}/vote`;
}

export function workspaceSelectionVoteSettingsPath(projectId, topicId) {
    return `${workspaceBase(projectId)}/vote/topics/${topicId}/settings`;
}

export function workspaceSelectionVotePrivilegedUsersPath(projectId, topicId) {
    return `${workspaceBase(projectId)}/vote/topics/${topicId}/privileged-users`;
}

export function workspaceSelectionVoteCasesPath(projectId, topicId) {
    return `${workspaceBase(projectId)}/vote/topics/${topicId}/cases`;
}

export function workspaceSelectionReviewsPath(projectId) {
    return `${workspaceBase(projectId)}/reviews`;
}

export function workspaceSelectionReviewPersonnelPath(projectId, stageId) {
    return `${workspaceBase(projectId)}/reviews/${stageId}/personnel-management`;
}

export function workspaceSelectionReviewTopicsPath(projectId, stageId) {
    return `${workspaceBase(projectId)}/reviews/${stageId}/topics`;
}

export function workspaceSelectionReviewScoringSettingsPath(projectId, stageId, topicId) {
    return `${workspaceBase(projectId)}/reviews/${stageId}/scoring-settings/${topicId}`;
}

export function workspaceSelectionReviewAssignPath(projectId, stageId) {
    return `${workspaceBase(projectId)}/reviews/${stageId}/assign`;
}

export function workspaceSelectionReviewResetAssignPath(projectId, stageId) {
    return `${workspaceBase(projectId)}/reviews/${stageId}/reset-assign`;
}

export function workspaceSelectionReviewCasesPath(projectId, stageId, topicId) {
    return `${workspaceBase(projectId)}/reviews/${stageId}/topics/${topicId}/cases`;
}

export function workspaceSelectionReviewCasePath(projectId, stageId, topicId, caseId) {
    return `${workspaceBase(projectId)}/reviews/${stageId}/topics/${topicId}/cases/${caseId}`;
}

export function workspaceSelectionReviewRankingPath(projectId, stageId, topicId) {
    return `${workspaceBase(projectId)}/reviews/${stageId}/topics/${topicId}/cases/list`;
}
